// Can not inherit from the Error class because it uses the name property which we need in sign-up GUI
export default class Exception {
    constructor(str, obj) {
        this.success = false;
        this.error = str;
        this.trace = new Error().stack;
        this.hint = "Manual exception.";
        if (obj) {
            this.details = obj;
        }
    }
}
